<template>
  <div class="p-25 bg-white" id="newOrder">
    <Form :model="order" :label-width="160" label-position="right" ref="orderForm" :rules="rules">
      <div class="f-20 m-b-10">
        河南省电子印章业务受理（社保专用）
      </div>
      <div class="c-gray b-t-1 m-b-15 f-14 p-t-10">
        <h4>单位信息</h4>
      </div>
      <FormItem label="单位类型：" prop="orgType" style="width:60%">
        <select-pro option-data="DictSocietySealsite_orgType" v-model="dzData.orgType"
                    placeholder="请选择单位类型" @on-change="">
        </select-pro>
      </FormItem>
      <FormItem label="单位名称：" prop="orgName" style="width:60%">
        <Input v-model="dzData.orgName" placeholder="请输入单位名称" type="textarea"></Input>
      </FormItem>
      <FormItem label="统一社会信用代码：" prop="orgUscc" style="width:60%">
        <Input v-model="dzData.orgUscc" placeholder="请输入统一社会信用代码" ></Input>
      </FormItem>
      <FormItem label="通讯地址：" prop="orgAddress" style="width:60%">
        <Input v-model="dzData.orgAddress" placeholder="请输入通讯地址" ref="companyAddressText" type="textarea"></Input>
      </FormItem>
      <FormItem label="社会保险登记编号：" prop="securityCode" style="width:60%">
        <Input v-model="dzData.securityCode" placeholder="" ></Input>
      </FormItem>
      <FormItem label="所属参保机构：" prop="securityInst" style="width:60%">
        <Input v-model="dzData.securityInst" placeholder="" ></Input>
      </FormItem>


      <div class="c-gray b-t-1 m-b-15 p-10 f-14">
        <h4>法定代表人</h4>
      </div>
      <FormItem label="姓名：" prop="crpName" style="width:60%">
        <Input v-model="dzData.crpName" placeholder="请输入法人代表姓名"></Input>
      </FormItem>
      <FormItem label="身份证号：" prop="crpCertNo" style="width:60%">
        <Input v-model="dzData.crpCertNo" placeholder="请输入法人代表身份证号"></Input>
      </FormItem>
      <FormItem label="手机号：" prop="crpPhone" style="width:60%">
        <Input v-model="dzData.crpPhone" placeholder="请输入法人代表手机号"></Input>
      </FormItem>

      <div class="c-gray b-t-1 m-b-15 p-10 f-14">
        <h4>经办人</h4>
      </div>
      <FormItem label="姓名：" prop="opName" style="width:60%">
        <Input v-model="dzData.opName" placeholder="请输入经办人姓名"></Input>
      </FormItem>
      <FormItem label="身份证号：" prop="opCertNo" style="width:60%">
        <Input v-model="dzData.opCertNo" placeholder="请输入经办人身份证号"></Input>
      </FormItem>
      <FormItem label="手机号：" prop="opPhone" style="width:60%">
        <Input v-model="dzData.opPhone" placeholder="请输入经办人手机号"></Input>
      </FormItem>
      <FormItem label="电子邮箱：" prop="opEmail" style="width:60%">
        <Input v-model="dzData.opEmail" placeholder="请输入经办人电子邮箱"></Input>
      </FormItem>

    </Form>

  </div>
</template>

<script>
  import {PhotoUpload, ImageView} from '@/components/libs'
  import {mapState} from 'vuex'
  import {api, dict, util} from '@/libs'
  import store from '@/modules'
  import setup from '@/setup'

  export default {
    components: {PhotoUpload, ImageView},
    data() {
      const _this = this;
      const param = {
        makeMd5Name: true,
        ossPath: 'society/client/user/:SPLIT:' + this.$store.state.custom.user.id + '/'
      }
      return {
        dzData: {},
        eSealPay: {},
        payModal: {
          show: false
        },
        showPrompt: true,
        showSelectSeal: true,
        materialActive: null,
        selectedMaterialIndex: null,
        step: parseInt(this.$route.query.step) || 0,
        opUseCrp: false,
        selectCompany: {},
        checkState: {},
        //办事大厅
        centerAddress: {},
        companyInfoModal: {
          show: false
        },
        usccOssParam: Object.assign({ocrJson: JSON.stringify({typeId: 3})}, param),
        certFrontparam: Object.assign({ocrJson: JSON.stringify({typeId: 1})}, param),
        //刻章店的查询参数
        params: {},
        //选择的刻章店检索
        shopSelectedIndex: null,
        form: {
          //营业执照
          usccOss: {
            name: 'usccOss',
            single: true,
            param: Object.assign({ocrJson: JSON.stringify({typeId: 3})}, param),
            list: []
          },
          //法人身份证正面
          crpCertFrontOss: {
            name: 'crpCertFrontOss',
            single: true,
            param: Object.assign({ocrJson: JSON.stringify({typeId: 1})}, param),
            list: [],
            success(payload, file) {
              Object.assign(_this.order, {
                crpCertFrontOss: payload.ossPath,
                crpName: payload.ocr.name,
                crpCertNo: payload.ocr.num,
              })
              _this.$forceUpdate()
            }
          },
          //法人身份证反面
          crpCertBackOss: {
            name: 'crpCertBackOss',
            single: true,
            param: param,
            list: [],
            success(payload, file) {
              Object.assign(_this.order, {
                crpCertBackOss: payload.ossPath
              })
              _this.$forceUpdate()
            }
          },
          //经办人身份证正面
          opCertFrontOss: {
            name: 'opCertFrontOss',
            single: true,
            param: Object.assign({ocrJson: JSON.stringify({typeId: 1})}, param),
            list: [],
            success(payload, file) {
              Object.assign(_this.order, {
                opCertFrontOss: payload.ossPath,
                opName: payload.ocr.name,
                opCertNo: payload.ocr.num,
              })
              _this.$forceUpdate()
            }
          },
          //经办人身份证反面
          opCertBackOss: {name: 'opCertBackOss', single: true, param: param, list: []},
          //授权委托书
          opPoaOss: {name: 'opPoaOss', single: true, param: param, list: []},
          //授权委托书
          matApplyOss: {
            name: 'matApplyOss',
            single: true,
            list: [],
            param: param,
            succes(payload, file) {
              Object.assign(_this.order, {matApplyOss: payload.matApplyOss})
              _this.$forceUpdate()
            }
          },
          //授权委托书
          matOssArrayJson: {name: 'matOssArrayJson', single: false, param: param, list: [],},


        },

        crpNouseOpRules: {
          //company
          usccOss: [{required: true, trigger: 'blur', message: '请上传营业执照'}],
          uscc: [{required: true, trigger: 'blur', message: '信用代码不能为空'}],
          name: [{required: true, trigger: 'blur', message: '企业名称不能为空'}],
          address: [{required: true, trigger: 'blur', message: '注册地址不能为空'}],
          aicDist6: [{required: true, trigger: 'change', message: '请选择所在县区'}],
          //crp
          crpCertFrontOss: [{required: true, trigger: 'blur', message: '请上传法人代表身份证正面'}],
          crpCertBackOss: [{required: true, trigger: 'blur', message: '请上传法人代表身份证背面'}],
          crpName: [{required: true, trigger: 'blur', message: '法人代表姓名不能为空'}],
          crpCertNo: [{required: true, trigger: 'blur', message: '请填写正确的身份证号'}],
          crpPhone: [{required: true, trigger: 'blur', pattern: util.pattern.phone, message: '请填写正确的手机号'}],
          //other
          // matApplyOss: [{ required: true, trigger: 'blur', message: '请上传公章刻制申请表照片' }]
        },
        rules: {},
        aicRules: {
          opCertFrontOss: [{required: true, trigger: 'blur', message: '请上传经办人身份证正面'}],
          opCertBackOss: [{required: true, trigger: 'blur', message: '请上传经办人身份证背面'}],
          opName: [{required: true, trigger: 'blur', message: '经办人姓名不能为空'}],
          opCertNo: [{required: true, trigger: 'blur', message: '请填写正确的身份证号'}],
          opPhone: [{required: true, trigger: 'blur', message: '请填写正确的手机号'}]
        },
        aicUseRules: {
          opCertFrontOss: [{required: true, trigger: 'blur', message: '请上传经办人身份证正面'}],
          opCertBackOss: [{required: true, trigger: 'blur', message: '请上传经办人身份证背面'}],
          opName: [{required: true, trigger: 'blur', message: '经办人姓名不能为空'}],
          opCertNo: [{required: true, trigger: 'blur', message: '请填写正确的身份证号'}],
          opPhone: [{required: true, trigger: 'blur', message: '请填写正确的手机号'}]
        },
        aicNoUseRules: {
          opName: [{required: true, trigger: 'blur', message: '经办人姓名不能为空'}],
          opCertNo: [{required: true, trigger: 'blur', message: '请填写正确的身份证号'}],
          opPhone: [{required: true, trigger: 'blur', message: '请填写正确的手机号'}]
        },
        //op
        opRules: {
          opCertFrontOss: [{required: true, trigger: 'blur', message: '请上传经办人身份证正面'}],
          opCertBackOss: [{required: true, trigger: 'blur', message: '请上传经办人身份证背面'}],
          opName: [{required: true, trigger: 'blur', message: '经办人姓名不能为空'}],
          opCertNo: [{required: true, trigger: 'blur', message: '请填写正确的身份证号'}],
          opPhone: [{required: true, trigger: 'blur', message: '请填写正确的手机号'}],
          opPoaOss: [{required: true, trigger: 'blur', message: '请上传法人授权委托书'}],
        },
        sealModal: {
          show: false,
          loading: true,
          seal: {name: '', sealType: ''},
          sealType: {},
          material: {},
          rules: {
            name: [{required: true, trigger: 'blur', message: '请输入印章名称'}],
            sealType: [{required: true, trigger: 'change', message: '请输选择印章类型'}],
            matId: [{required: true, trigger: 'change', message: '请输选择印章材质', type: 'number'}]
          }
        },
        material: [],

        ship: {
          dist6: [],
          deliverType: {}
        },
        nowOrder: {},
        mapModal: {
          baiduMapAk: setup.baiduAk,
          show: false,
          center: setup.mapCenter
        }
      }
    },
    watch: {
      $route(route) {
        this.step = parseInt(route.query.step) || 0
      }
    },
    computed: {
      ...mapState({
        company: state => state.order.current.company,
        pageConfig: state => state.main.config
      }),
      totlePrice() {
        return this.order.seals.reduce((first, second) => first + second.matPrice, 0)
      },
      order() {
        const payload = store.state.order.current.order
        this.showPrompt = payload.usccOss ? false : true
        if (payload.orderType == 1) this.showPrompt = false
        if (this.$route.query.companyId) payload.companyId = this.$route.query.companyId

        return payload
      },
      orderPay() {
        if (this.order.id) {
          return {
            wxPaySrc: api.baseUrl + api.gzwCusOrder.orderPayWxScan + this.order.id + '?token=' + localStorage.getItem('pcCustomToken'),
            aliPayUrl: api.baseUrl + api.gzwCusOrder.orderPayAlipayPc + this.order.id + '?token=' + localStorage.getItem('pcCustomToken'),
            plateform: 0
          }

        } else return {
          plateform: 0
        }
      },

    },
    methods: {
      usccOssSuccess(payload) {
        this.showPrompt = false
        Object.assign(this.order, {
          usccOss: payload.ossPath,
          name: payload.ocr.name,
          crpName: payload.ocr.person,
          uscc: payload.ocr.reg_num,
        })
        this.order.company.dist6 = payload.ocr.reg_num.substr(2, 6)
        this.order.aicDist6 = payload.ocr.reg_num.substr(2, 6)
        this.params.dist6 = this.order.aicDist6
        this.order.address = payload.ocr.address
        store.dispatch('order/getCompanySelectList', {dist6: this.order.company.dist6}).then(res => this.$forceUpdate())
      },
      crpCertFrontOssSuccess(payload) {
        Object.assign(this.order, {
          crpCertFrontOss: payload.ossPath,
          crpName: payload.ocr.name,
          crpCertNo: payload.ocr.num,
        })
        this.$forceUpdate()
      },
      crpCertBackOssSuccess(payload) {
        Object.assign(this.order, {
          crpCertBackOss: payload.ossPath
        })
        this.$forceUpdate()
      },
      opCertFrontOssSuccess(payload) {
        Object.assign(this.order, {
          opCertFrontOss: payload.ossPath,
          opName: payload.ocr.name,
          opCertNo: payload.ocr.num,
        })
        this.$forceUpdate()
      },
      opCertBackOssSuccess(payload) {
      },
      //法人授权委托书
      opPoaOssSuccess(payload) {
      },
      //获取刻章店列表
      getCompanySelectList(page) {
        const arr = [], jsonConditions = {}
        console.log("getCompanySelectList, page=", page)
        if (this.params.dist6) {
          if (this.params.dist6.substr(2, 2) == '00') {
            arr.push({op: "startswith", param: "dist6", values: this.params.dist6.substr(0, 2)})
          } else {
            if (this.params.dist6.substr(4, 2) == '00') {
              arr.push({op: "startswith", param: "dist6", values: this.params.dist6.substr(0, 4)})
            } else {
              arr.push({op: "startswith", param: "dist6", values: this.params.dist6})
            }
          }
        }
        if (this.params.search) {
          arr.push({op: "contains", param: "name", values: this.params.search})
        }
        if (this.order.aicDist6 == null) {
          this.order.aicDist6 = this.order.uscc.substr(2, 6)
        }
        if (arr.length) {
          // Object.assign(jsonConditions, {op: "and", elements: arr})
          store.dispatch('order/getCompanySelectList', {
            page: page - 1,
            dist6: this.order.aicDist6,
            jsonConditions: JSON.stringify({op: "and", elements: arr})
          }).then(() => this.$forceUpdate())
        } else {
          store.dispatch('order/getCompanySelectList', {
            page: page - 1,
            dist6: this.order.aicDist6
          }).then(() => this.$forceUpdate())
        }
      },
      // 翻页
      stepNext(page) {
        console.log("stepNext", page)
        if (this.order.orderState > 0) {
          if (page === 3) this.$router.push({path: '/center/seal/order/current'})
          else this.$router.push({path: this.$route.path, query: {id: this.order.id, step: page}})
        } else {
          if (page === 1) {
            if (this.order.aicDist6 == null) {
              this.order.aicDist6 = this.order.uscc.substr(2, 6)
            }
            this.params.dist6 = this.order.aicDist6
            this.getCompanySelectList()
          }

          if (page == 3 && this.order.seals == 0) {
            this.$Notice.warning({
              title: '请先增加印章'
            })
          } else {
            this.$router.push({path: this.$route.path, query: {id: this.order.id, step: page}})
            this.step = page
            Object.assign(this.order, {
              deliverPersonName: this.order.deliverType == 1 ? this.order.crpName : '',
              deliverPersonPhone: this.order.deliverType == 1 ? this.order.crpPhone : ''
            })
          }
          if (page == 3 && this.$route.query.step == 3) {
            this.setDevliverType()
          }
        }
      },
      setDevliverType() {
        dict.dict('EntityGzwOrder_deliverType').then(payload => {
          const arr = [], arr1 = []
          if (this.order.company.bizSetupJsonStr && this.order.company.bizSetupJsonStr.deliver) {
            if (this.order.company.bizSetupJsonStr.deliver.shop) arr.push(Object.entries(payload.content)[0])
            if (this.order.company.bizSetupJsonStr.deliver.express) arr.push(Object.entries(payload.content)[1])
            if (this.order.company.bizSetupJsonStr.deliver.center) arr.push(Object.entries(payload.content)[2])
            this.centerAddress = this.order.company.bizSetupJsonStr.deliver.centerAddress
            const obj = {}
            arr.forEach(item => {
              obj[item[0]] = item[1]
            })
            this.ship.deliverType = obj
          } else {
            arr1.push(Object.entries(payload.content)[0])
            arr1.push(Object.entries(payload.content)[1])
            const obj1 = {}
            arr1.forEach(item => {
              obj1[item[0]] = item[1]
            })
            this.ship.deliverType = obj1
          }
        })
      },

      // 经办人使用法人
      opUseCrpFun() {
        if (this.opUseCrp) {
          Object.assign(this.order, {
            opName: this.order.crpName,
            opCertNo: this.order.crpCertNo,
            opPhone: this.order.crpPhone,
            opCertFrontOss: this.order.crpCertFrontOss,
            opCertBackOss: this.order.crpCertBackOss,
            opPoaOss: ''
          })
          Object.assign(this.form.opCertFrontOss, {
            list: this.form.crpCertFrontOss.list,
            uploadFiles: this.form.crpCertFrontOss.uploadFiles
          })
          Object.assign(this.form.opCertBackOss, {
            list: this.form.crpCertBackOss.list,
            uploadFiles: this.form.crpCertBackOss.uploadFiles
          })
          this.rules = Object.assign({}, this.crpNouseOpRules)
          this.aicRules = Object.assign({}, this.aicNoUseRules)
        } else {
          this.rules = Object.assign({}, this.crpNouseOpRules, this.opRules)
          this.aicRules = Object.assign({}, this.aicUseRules)
        }
      },


      saveOrderInfo() {
        store.dispatch('order/postNewEditOrder', {
          orderJson: this.order,
          id: this.order.id
        }).then(payload => {
          this.$router.push({path: this.$route.path, query: {id: this.order.id, step: 1}})
          this.stepNext(1)
        })
      },

      //保存订单
      saveOrder() {
        this.saveOrderInfo();
        // if (!this.order.orderType || this.order.orderType == 0) {
        //     this.$refs.orderForm.validate(valid => {
        //         if (valid) {
        //             this.saveOrderInfo()
        //         }
        //     })
        // } else {
        //     if(!this.isAgree) {
        //         this.$Notice.warning({title: '请先阅读并勾选委托内容'})
        //     } else {
        //         this.$refs.aicOrderForm.validate(valid => {
        //             if (valid) {
        //                 this.saveOrderInfo()
        //             }
        //         })
        //     }
        // }
      },
      //设置周期调用
      polling(type) {
        const _this = this
        this.checkState = setInterval(() => {
          store.dispatch('order/getOrderInfoById', {
            id: _this.$route.query.id
          })
          if (_this.order.orderState === '1') {
            clearInterval(_this.checkState)
            _this.$router.push({
              path: '/center/seal/order/current'
            })
          }
        }, 1000)
        this.payModal.payType = type
      },
      //取消周期调用
      cancelPay() {
        debugger
        clearInterval(this.checkState)
      },
      //保存刻章店
      saveSealShop() {
        if (this.order.companyId) {
          store.dispatch('order/postNewEditOrder', {
            id: this.order.id,
            orderJson: this.order
          }).then(() => {
            this.stepNext(2)
            this.selectCompanyId(this.order.companyId)
          })
        } else {
          this.$Notice.warning({
            title: '请选择刻章店'
          })
        }
      },

      // 保存印章
      saveSeal() {
        if (this.sealModal.seal.id) this.sealModal.seal.matId = this.sealModal.seal.id
        const seal = this.sealModal.seal
        this.$refs.sealForm.validate(valid => {
          if (valid) {
            store.dispatch('order/postOrderSeal', {
              id: seal.id,
              orderId: this.order.id,
              sealJson: seal
            }).then(payload => {
              seal.id ? Object.assign(this.order.seals.find(item => item.id == seal.id), payload) : this.order.seals.push(payload)
              this.$forceUpdate()
              this.sealModal.show = false
            }, payload => this.sealModal.loading = false)
          } else {
            this.sealModal.loading = false
          }
          setTimeout(() => {
            this.sealModal.loading = true
          })
        })
      },

      // 删除印章
      removeSeal(item, index) {
        const _this = this
        this.$Modal.confirm({
          title: '删除印章',
          content: item.name,
          onOk() {
            store.dispatch('order/removeOrderSeal', {id: item.id}).then(payload => {
              _this.order.seals.splice(index, 1)
              _this.$forceUpdate()
            })
          }
        })
      },


      // 选择印章类型
      sealTypeChangeFun(item) {
        if (item.value) {
          if (item.value == '05') {
            this.$set(this.sealModal.seal, 'name', this.order.crpName + '印')
          } else if (item.value == '99' || item.value == '01') {
            this.$set(this.sealModal.seal, 'name', this.order.name)
          } else {
            this.$set(this.sealModal.seal, 'name', this.order.name + item.label)
          }
          this.material = this.$store.state.order.current.material.filter(node => node.sealType == item.value)
        }
      },

      //新增印章
      newSealFormFun() {
        this.$forceUpdate()
        this.materialActive = null
        this.selectedMaterialIndex = null
        this.$refs.sealForm.resetFields()
        Object.assign(this.sealModal, {
          show: true,
          loading: true,
          seal: {orderId: this.order.id, name: ''},
          material: {}
        })
        this.material = []
        this.sealModal.seal.sealType = '01'
        this.sealTypeChangeFun({value: '01'})
      },

      // 编辑印章
      selectSealEditFun(item) {
        this.$refs.sealForm.resetFields()
        const material = this.material.find(node => node.id == item.matId) || {}
        Object.assign(this.sealModal, {
          show: true,
          loading: true,
          material: JSON.parse(JSON.stringify(material)),
          seal: JSON.parse(JSON.stringify(item))
        })
      },

      //选择印章材料
      materialChangeFun(val) {
        if (val) {
          this.sealModal.material = this.material.find(item => item.id == val)
        }
      },

      // 选择收货方式
      selectDevliverType() {
        Object.assign(this.order, {
          deliverPersonName: this.order.deliverType == 1 ? this.order.crpName : '',
          deliverPersonPhone: this.order.deliverType == 1 ? this.order.crpPhone : ''
        })
      },

      //保存收货信息
      saveShip() {
        let _this = this
        if (this.order.deliverType == 1 && this.order.deliverDist6 && this.order.deliverAddress || this.order.deliverType == 0 || this.order.deliverType == 2) {
          store.dispatch('order/postNewEditOrder', {
            id: this.order.id,
            orderJson: this.order
          }).then(payload => this.stepNext(4))
        } else {
          this.$Notice.error({title: '填写正确的收货地址'})
        }

        // store.dispatch('order/getOrderInfoById', {id: this.$route.query.id}).then(payload => {
        //     if (payload.orderState == 1) {
        //         this.$router.push({path: '/center/seal/order/current'})
        //     } else {
        //         this.$Notice.warning({title: '当前订单未完成支付！'})
        //     }
        // })
      },

      selectCompanyId(val) {
        if (val) {
          store.dispatch('order/queryMaterial', val)
        }
      },
      mapHandler(BMap, map) {
        const _this = this
        _this.m = _bMap(map)
        _this.m.getLocation().then(payload => {
          _this.point = payload
        })
      },
      setMapAddress() {
        if (this.$refs.companyAddressText.value != '--') {
          this.mapModal.center = this.$refs.companyAddressText.value
        } else {
          this.mapModal.center = setup.mapCenter + ''
        }
      },
      // finishPay() {
      //     store.dispatch('order/getOrderInfoById', {id: this.$route.query.id}).then(payload => {
      //         if (payload.orderState == 1) {
      //             this.$router.push({path: '/center/seal/order/current'})
      //         } else {
      //             this.$Notice.warning({title: '当前订单未完成支付！'})
      //         }
      //     })
      // },
      onMouseOver() {
        this.materialActive = index
      },
      onMouseOut() {
        this.materialActive = null
      },
      showCompanyInfo() {
        this.selectCompany = this.company.poi.find(item => item.id == this.order.companyId)
      }
    },

    created() {
      if (this.$route.query.id) {
        store.dispatch('order/getOrderInfoById', {id: this.$route.query.id}).then(payload => {
          if (payload.uscc) {
            store.dispatch('order/getCompanySelectList', {dist6: payload.uscc.substr(2, 6)}).then(res => this.$forceUpdate())
          }
          if (payload.aicDist6) {
            store.dispatch('order/getCompanySelectList', {dist6: payload.aicDist6}).then(res => this.$forceUpdate())
          }
          if (payload.opCertNo === payload.crpCertNo && payload.opCertNo !== undefined) this.opUseCrp = true
          this.opUseCrpFun()
          if (payload.company) {
            this.order.companyId = payload.company.id
            this.selectCompanyId(this.order.companyId)
            this.shopSelectedIndex = this.company.poi.findIndex(item => item.id === this.order.companyId)
          }
        })
      } else {
        store.commit('order/SET_CURRENT_ORDER_INFO', {
          crpCertType: '111',
          opCertType: '111',
          company: {},
          seals: []
        })
        this.opUseCrpFun()
      }
      if (this.$route.query.companyId) {
        this.showSelectSeal = false
        this.order.companyId = this.$route.query.companyId
        this.selectCompanyId(this.order.companyId)
      }
      dict.dict('DictSocietySealsite_sealType').then(payload => this.sealModal.sealType = payload.content)
      this.setDevliverType()
      console.log(this.order.companyId, !this.showPrompt, this.order.seals, this.order.seals.length < 1, !(this.order.orderState > 0))
    }

  }
</script>

<style lang="less">
  /*.map {*/
  /*width: 100%;*/
  /*height: 600px*/
  /*}*/

  /*.box {*/
  /*box-shadow: 0px 2px 8px #bbb;*/
  /*}*/

  /*.selected {*/
  /*margin-left: -8px;*/
  /*position: absolute;*/
  /*top: 0px;*/
  /*opacity: 0.4;*/
  /*background: #000;*/
  /*width: 100%;*/
  /*height: 100%;*/
  /*}*/

  /*.selected1 {*/
  /*position: absolute;*/
  /*top: 0px;*/
  /*width: 100%;*/
  /*height: 100%;*/
  /*}*/

  /*.boxShadow {*/
  /*box-shadow: 0px 1px 11px #999;*/
  /*}*/
</style>
